import deTranslations from './de.json'
import enTranslations from './en.json'
import frTranslations from './fr.json'
import nlTranslations from './nl.json'

export const languages = [
    { code: 'nl', label: 'Nederlands', translations: nlTranslations },
    { code: 'en', label: 'English', translations: enTranslations },
    { code: 'de', label: 'Deutsch', translations: deTranslations },
    { code: 'fr', label: 'Français', translations: frTranslations },
] as const
